<style lang="stylus">
    .property-container
        padding 12px 20px 0 20px
        position relative
        background-color $right-view-backcolor
        height calc(100% - 60px)
        overflow-y auto
        overflow-x hidden
        .property-newBtn
            width 150px
            height 30px
            border 1px solid var(--border-color-propertyset-btn)
            box-shadow var(--box-shadow-color-small)
            border-radius 6px
            background-color var(--bg-color-white)
            color $right-view-content-textcolor
            text-align center
            line-height 28px
            margin 0 auto
            margin-bottom 15px
            user-select none
            cursor pointer
            transition background-color .2s linear
            &:not(.ban-newBtn):hover
                background-color var(--themeColor)
                color #fff
        .ban-newBtn
            filter grayscale(.8)
            opacity .6
            cursor not-allowed
        .property-box
            width 200px
            height 51px
            margin-bottom 15px
            border 1px solid $box-bordercolor
            border-radius 6px
            background-color var(--bg-color-primary)
            overflow hidden
            .property-namebox
                position relative
                width 100%
                height 25px
                border-bottom 1px solid $box-bordercolor
                .namebox-title
                    float left
                    max-width 48%
                    padding-right 14px
                    color $right-view-content-textcolor
                    text-indent 10px
                    line-height 25px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                .namebox-description
                    padding-right 20px
                    color #d0d0d0
                    text-indent 10px
                    line-height 25px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    transform scale(0.95)
                .namebox-menu
                    position absolute
                    right 0
                    top 0
                    width 14px
                    height 100%
                    user-select none
                    cursor pointer
                    .item-icon
                        position absolute
                        right 5px
                        top 4px
                        width 6px
                        height 16px
            .property-contentbox
                display flex
                justify-content space-between
                .contentbox-input input,.contentbox-input .ivu-select-selection
                    border unset !important
                    outline unset
                    border-radius unset
                .contentbox-colorLine
                    display flex
                    justify-content space-between
                    width 100%
                    .colorLine-colorbtn
                        colorbtn()
                        border unset
                        width 32px
                        height 24px
        .expand-menu
            position absolute
            right 0
            overflow auto
            background-color var(--bg-color-tertiary)
            box-shadow $box-shadow
            border-radius 6px
            padding 6px
            z-index 1
            >p
                width 100%
                padding 5px 10px
                border-radius 6px
                &:hover
                    background-color $main-hovercolor


    .expand-exportbox
        position relative
        height 60px
        display flex
        justify-content center
        align-items center
        pointer-events none
        .expand-btn
            width 200px
            height 28px
            line-height 28px
            background var(--themeColor)
            border 1px solid rgba(0, 0, 0, 0.1)
            box-shadow var(--box-shadow-color-small)
            border-radius 6px
            pointer-events auto
            p
                text-align center
                color #fff
                font-size 12px
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
            &:hover
                background var(--themeHover)
            &.ban
                filter opacity(0.5)
                pointer-events none
        .expand-targetbox
            position absolute
            top -68px
            width 200px
            height 80px
            padding 8px 6px
            background var(--bg-color-tertiary)
            box-shadow $box-shadow
            border-radius 8px
            pointer-events auto
            .expand-item
                display flex
                align-items center
                height 32px
                border-radius 6px
                &:not(.ban):hover
                    background var(--hover-color-common-6)
                p
                    width 100%
                    padding 0 6px
                    text-align center
                    overflow hidden
                    white-space nowrap
                    text-overflow ellipsis
                    color var(--text-color-primary)
                    font-size 12px
                &.ban
                    pointer-events none
                    p
                        color var(--text-color-property-ban-item)
</style>

<template>
    <setbox :setTitle="$t('title')" :noPadding="true">
        <div class="property-container" ref="scrollBox">
            <div class="property-newBtn" :class="{ 'ban-newBtn': !isSelect || !canCreateAtt }" @click="isSelect && canCreateAtt && createProperty()">
                {{ $t("newProperty") }}
            </div>

            <div class="property-box" v-for="item in shapeDataList">
                <div class="property-namebox">
                    <p class="namebox-title" :title="item.transName || item.name">{{ item.transName || item.name }}</p>
                    <p class="namebox-description" :title="item.description">{{ item.description }}</p>
                    <div class="namebox-menu" @click="isSelect && showMenus($event, item.id)">
                        <iconSymbol class="item-icon" name="property-menu"></iconSymbol>
                    </div>
                </div>
                <div class="property-contentbox">
                    <Input
                        class="contentbox-input"
                        v-if="['string', 'number', 'duration', 'currency', 'percentage', 'scientific'].includes(typeList[item.type])"
                        v-model="item.displayValue"
                        size="small"
                        style="width: 100%"
                        :disabled="item.disabled"
                        @on-focus="
                            editLocker('focus', 'inputLocker', () => {
                                setTempInput(item.displayValue);
                            }),
                                setSelectID(item.id)
                        "
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                submitChangeValue();
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    />

                    <DatePicker
                        class="contentbox-input"
                        v-if="typeList[item.type] == 'dateTime'"
                        :clearable="false"
                        v-model="dateList[item.id]['date']"
                        type="date"
                        size="small"
                        style="width: 49%"
                        @on-change="setDate"
                        @on-open-change="setSelectID(item.id)"
                    ></DatePicker>
                    <TimePicker
                        class="contentbox-input"
                        v-if="typeList[item.type] == 'dateTime'"
                        v-model="dateList[item.id]['time']"
                        type="time"
                        size="small"
                        style="width: 50%"
                        @on-change="setTime"
                        @on-open-change="setSelectID(item.id)"
                    ></TimePicker>

                    <i-select
                        class="contentbox-input"
                        v-if="typeList[item.type] == 'boolean'"
                        v-model="dateList[item.id]['boolean']"
                        style="width: 100%"
                        size="small"
                        @on-change="submitChangeValue()"
                        @on-open-change="setSelectID(item.id)"
                    >
                        <i-option :value="'true'" :label="'true'"></i-option>
                        <i-option :value="'false'" :label="'false'"></i-option>
                    </i-select>

                    <i-select
                        class="contentbox-input"
                        v-if="typeList[item.type] == 'list'"
                        v-model="item.value"
                        style="width: 100%"
                        size="small"
                        @on-change="submitChangeValue()"
                        @on-open-change="setSelectID(item.id)"
                    >
                        <i-option style="display: none" :value="item.value" :label="item.transValue" :key="0"></i-option>
                        <i-option :value="item" :label="item" v-for="(item, index) in listList[item.id]" :key="index + 1"></i-option>
                    </i-select>

                    <div class="contentbox-colorLine" v-if="typeList[item.type] == 'color'">
                        <Input
                            class="contentbox-input"
                            v-model="item.displayValue"
                            size="small"
                            style="width: 80%"
                            @on-focus="
                                editLocker('focus', 'inputLocker', () => {
                                    setTempInput(item.displayValue);
                                }),
                                    setSelectID(item.id)
                            "
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    submitChangeValue();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        />
                        <div class="colorLine-colorbtn" @click="showColor($event, item.id)">
                            <div :style="{ backgroundColor: item.displayValue }"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="expand-menu" v-show="showExpandMenu" :style="{ top: `${menuTop}px` }">
                <p v-show="selectIndex != 0" @click="isSelect && moveup()">{{ $t("moveup") }}</p>
                <p v-show="selectIndex != shapeDataList.length - 1" @click="isSelect && movedown()">{{ $t("movedown") }}</p>
                <p @click="isSelect && editProperty()">{{ $t("editData") }}</p>
                <p @click="isSelect && delProperty()">{{ $t("delData") }}</p>
            </div>
        </div>

        <div class="expand-exportbox" v-click-outside="closeExpandTool">
            <div class="expand-targetbox" v-show="showExpandTool">
                <div class="expand-item" :class="{ ban: !shapeDataList.length || !isSelect }" @click="exportSelectedShapeDatas">
                    <p :title="$t('exportSelect')">{{ $t("exportSelect") }}</p>
                </div>
                <div class="expand-item" @click="exportShapeDatas">
                    <p :title="$t('exportPage')">{{ $t("exportPage") }}</p>
                </div>
            </div>
            <div class="expand-btn" @click="showExpandTool = !showExpandTool">
                <p>{{ $t("export") }}</p>
            </div>
        </div>
    </setbox>
</template>

<script lang="ts">
    declare var EDProperty: any;
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import setbox from "./BaseSet.vue";

    @Component({
        components: {
            setbox,
        },
    })
    export default class Property extends Vue {
        @Inject()
        ["iviewInputBlur"];

        tempInput: any;
        menuTop: number = 0;
        menuObj: any;
        showExpandMenu: boolean = false;
        selectID: number = -1;
        selectIndex: number = 0;
        dateList: object = {};
        listList: object = {};
        typeList: Array<string> = [
            "string",
            "number",
            "dateTime",
            "duration",
            "currency",
            "boolean",
            "list",
            "",
            "color",
            "percentage",
            "scientific",
        ];
        createProperty() {
            // temp
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ShapeData",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        editProperty() {
            this.$store.commit("setShapeStatus", {
                type: "shapeDataID",
                data: this.selectID,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ShapeData",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        delProperty() {
            if (this.selectIndex != -1) {
                this.shapeDataList.splice(this.selectIndex, 1);
                console.log("***", this.selectIndex, this.selectID);
                window["_view"].deleteShapeProp(this.selectIndex);
            }
        }
        moveup() {
            [this.shapeDataList[this.selectIndex], this.shapeDataList[this.selectIndex - 1]] = [
                this.shapeDataList[this.selectIndex - 1],
                this.shapeDataList[this.selectIndex],
            ];
            this.submitAll();
        }
        movedown() {
            [this.shapeDataList[this.selectIndex], this.shapeDataList[this.selectIndex + 1]] = [
                this.shapeDataList[this.selectIndex + 1],
                this.shapeDataList[this.selectIndex],
            ];
            this.submitAll();
        }
        showMenus(e, ID) {
            for (let i = 0; i < this.shapeDataList.length; ++i) {
                if (this.shapeDataList[i]["id"] == ID) {
                    this.selectIndex = i;
                    break;
                }
            }
            let dom = this.$refs.scrollBox as HTMLElement as HTMLElement;
            this.showExpandMenu = true;
            let target = e.target.tagName == "svg" ? e.target.parentNode : e.target;
            this.menuObj = target;
            this.menuTop = e.pageY + target.offsetHeight - e.offsetY - 180 + dom.scrollTop;
            this.selectID = ID;
            window.addEventListener("click", this.closeMenu);
        }
        closeMenu(e) {
            let objTarget = this.menuObj;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.showExpandMenu = false;
                this.selectIndex = -1;
                window.removeEventListener("click", this.closeMenu);
            }
        }
        setDateList(arr) {
            for (let i = 0; i < arr.length; ++i) {
                if (this.typeList[arr[i]["type"]] == "dateTime") {
                    let dataArr = arr[i]["value"].split(" ") || [];
                    let obj = {
                        date: dataArr.length > 0 ? dataArr[0] : "",
                        time: dataArr.length > 0 ? dataArr[1] : "",
                    };
                    this.dateList[arr[i]["id"]] = obj;
                } else if (this.typeList[arr[i]["type"]] == "boolean") {
                    this.dateList[arr[i]["id"]] = {
                        boolean: arr[i]["value"].toString(),
                    };
                } else if (this.typeList[arr[i]["type"]] == "list") {
                    let value = [];
                    if (arr[i]["transFormat"]) {
                        value = arr[i]["transFormat"].split(";");
                    } else {
                        value = arr[i]["format"].split(";");
                    }
                    if (arr[i]["format"] == "EDDATEFORMAT") {
                        //  日期格式 特殊处理
                        value = [
                            "yyyy-MM-dd",
                            "yyyy/M/d",
                            "M/d/yyyy",
                            "M/d/yy",
                            "d/M/yyyy",
                            "d/M/yy",
                            "M.d.yyyy",
                            "d.M.yyyy",
                            "yy-M-d",
                            "MM-dd-yy",
                            "MMMM dyyyy",
                            "ddddMMMM ddyyyy",
                            "d MMMM yyyy",
                            "d-MMM-yy",
                            "MMM.dyy",
                            "MMMM yy",
                            "MMM-yy",
                            "yyyy",
                            "MMM",
                            "M/d/yyyy h:mm:ss ap",
                            "M/d/yyyy h:mm ap",
                            "d/M/yyyy h:mm:ss ap",
                            "d/M/yyyy h:mm ap",
                            "h:mm ap",
                            "h:mm:ss ap",
                            "hh:mm",
                            "hh:mm:ss",
                            "hh",
                            "mm",
                            "ss",
                        ];
                    }
                    this.listList[arr[i]["id"]] = value;
                }
            }
        }
        setDate(v) {
            this.submitChangeValue();
        }
        setTime(v) {
            this.submitChangeValue();
        }
        setSelectID(ID) {
            this.selectID = ID;
        }
        setTempInput(v) {
            this.tempInput = v;
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                        fn();
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        showColor(e, ID) {
            this.selectID = ID;
            let node = e.target;
            let payload = {
                type: this.fmtType.OnceColor,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "OnceColor" });
            });
        }
        submitChangeValue() {
            let value;
            for (let i = 0; i < this.shapeDataList.length; ++i) {
                if (this.shapeDataList[i]["id"] == this.selectID) {
                    if (this.shapeDataList[i]["displayValue"] == this.tempInput) return;

                    if (["number", "currency", "duration", "percentage", "scientific"].includes(this.typeList[this.shapeDataList[i]["type"]])) {
                        // value = parseFloat((this.shapeDataList[i]['displayValue'].match(/[0-9-\.]/g) || [0]).join(''));
                        value = parseFloat(this.shapeDataList[i]["displayValue"]);
                        if (isNaN(value)) {
                            this.$edMessage.error(this.$t("invalidVal"));
                            return;
                        }
                        if (this.typeList[this.shapeDataList[i]["type"]] == "percentage") {
                            //百分数手动除100
                            value /= 100;
                        }
                    } else if (this.typeList[this.shapeDataList[i]["type"]] == "list") {
                        value = this.shapeDataList[i]["value"];
                    } else if (this.typeList[this.shapeDataList[i]["type"]] == "boolean") {
                        value = this.dateList[this.selectID]["boolean"] == "false" ? false : true;
                    } else if (this.typeList[this.shapeDataList[i]["type"]] == "dateTime") {
                        let date = new Date(this.dateList[this.selectID]["date"]);
                        let timeArr = this.dateList[this.selectID]["time"].split(":");
                        date && date.setHours(timeArr[0]);
                        date && date.setMinutes(timeArr[1]);
                        date && date.setSeconds(timeArr[2]);
                        value = date;
                    } else {
                        value = this.shapeDataList[i]["displayValue"];
                    }

                    window["_view"].setShapeProp(this.selectID, value);
                }
            }
        }
        submitAll() {
            let value;
            for (let i = 0; i < this.shapeDataList.length; ++i) {
                if (this.shapeDataList[i]["id"] == this.selectID) {
                    if (this.shapeDataList[i]["displayValue"] == this.tempInput) return;

                    if (["number", "currency", "duration", "percentage", "scientific"].includes(this.typeList[this.shapeDataList[i]["type"]])) {
                        // value = parseFloat((this.shapeDataList[i]['displayValue'].match(/[0-9\.]/g) || [0]).join(''));
                        value = parseFloat(this.shapeDataList[i]["displayValue"]);
                        if (isNaN(value)) {
                            this.$edMessage.error(this.$t("invalidVal"));
                            return;
                        }
                        if (this.typeList[this.shapeDataList[i]["type"]] == "percentage") {
                            //百分数手动除100
                            value /= 100;
                        }
                    } else if (this.typeList[this.shapeDataList[i]["type"]] == "list") {
                        value = this.shapeDataList[i]["value"];
                    } else if (this.typeList[this.shapeDataList[i]["type"]] == "boolean") {
                        value = this.dateList[this.selectID]["boolean"] == "false" ? false : true;
                    } else if (this.typeList[this.shapeDataList[i]["type"]] == "dateTime") {
                        let date = new Date(this.dateList[this.selectID]["date"]);
                        let timeArr = this.dateList[this.selectID]["time"].split(":");
                        date && date.setHours(timeArr[0]);
                        date && date.setMinutes(timeArr[1]);
                        date && date.setSeconds(timeArr[2]);
                        value = date;
                    } else {
                        value = this.shapeDataList[i]["displayValue"];
                    }

                    window["_view"].updateShapeProp(this.shapeDataList);
                }
            }
        }

        showExpandTool = false;
        closeExpandTool() {
            this.showExpandTool = false;
        }
        exportShapeDatas() {
            // 判断导出数据为空
            if (window["_view"]._activePage.exportCheck()) {
                this.$edMessage.error(this.$t("exportError"));
                return;
            }
            window["_view"].exportShapeData();
            this.showExpandTool = false;
        }
        exportSelectedShapeDatas() {
            window["_view"].exportSelectShapeData();
            this.showExpandTool = false;
        }

        mounted() {}

        created() {
            console.log(1234);
        }
        activated() {
            this.$bus.$emit("setRightViewTitle", "propertySet");
        }
        @Watch("onceColor")
        watchColor(val) {
            if (val && /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(val)) {
                for (let i = 0; i < this.shapeDataList.length; ++i) {
                    if (this.shapeDataList[i]["id"] == this.selectID) {
                        this.shapeDataList[i]["displayValue"] = val;
                        this.submitChangeValue();
                    }
                }
            }
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get onceColor() {
            return this.$store.state.ui.onceColor;
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get canCreateAtt() {
            let arr = ["ConnectLine"];
            return !arr.includes(this.$store.state.shape.type);
        }
        get shapeDataList() {
            this.setDateList(this.$store.state.shape.shapeData);
            if (!this.$store.state.shape.isActived) {
                return [];
            }
            return this.$store.state.shape.shapeData;
        }
        set shapeDataList(v) {
            this.$store.commit("setShapeStatus", {
                type: "shapeData",
                data: v,
            });
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "数据属性",
    "newProperty": "编辑数据",
    "editData": "编辑",
    "delData": "删除",
    "moveup": "上移",
    "movedown": "下移",
    "invalidVal": "无效数值",
    "exportError": "没有可以导出的属性。",
    "export": "导出数据",
    "exportSelect": "导出选中的形状数据",
    "exportPage": "导出整页形状数据"
  },
  "en": {
    "title": "Data Propertits",
    "newProperty": "Manage Data",
    "editData": "Modify",
    "delData": "Delete",
    "moveup": "Move up",
    "movedown": "Move down",
    "invalidVal": "Invalid value",
    "exportError": "There is no property.",
    "export": "Export Data",
    "exportSelect": "Export data information of selected shapes",
    "exportPage": "Export data information of all shapes in this page"
  },
  "fr": {
    "title": "Attribut",
    "newProperty": "éditer les données",
    "editData": "éditer",
    "delData": "Effacer",
    "moveup": "Déplacer vers haut",
    "movedown": "Déplacer vers bas",
    "invalidVal": "Valeur Invalide",
    "exportError": "Il n'y a pas de propriété.",
    "export": "Exporter les données",
    "exportSelect": "Exporter des informations de données des formes sélectionnées",
    "exportPage": "Exporter les informations de données de toutes les formes dans cette page"
  },
  "de": {
    "title": "Dateneigenschaften",
    "newProperty": "Daten verwalten",
    "editData": "Modifizieren",
    "delData": "Löschen",
    "moveup": "Nach oben",
    "movedown": "Nach unten",
    "invalidVal": "Ungültige Daten",
    "exportError": "Keine Eigenschaften vorhanden..",
    "export": "Daten exportieren",
    "exportSelect": "Exportieren Sie die Dateninformationen der ausgewählten Formen",
    "exportPage": "Exportieren Sie Dateninformationen zu allen Formen auf dieser Seite"
  },
  "jp": {
    "title": "プロパティ",
    "newProperty": "データを編集",
    "editData": "編集",
    "delData": "削除",
    "moveup": "上に移動",
    "movedown": "下に移動",
    "invalidVal": "無効な値",
    "exportError": "プロパティはありません。",
    "export": "データのエクスポート",
    "exportSelect": "選択した図形のデータ情報をエクスポートします",
    "exportPage": "このページのすべての図形のデータ情報をエクスポートします"
  },
  "es": {
    "title": "Data Propertits",
    "newProperty": "Administrar datos",
    "editData": "Modificar",
    "delData": "Borrar",
    "moveup": "Mover arriba",
    "movedown": "Mover abajo",
    "invalidVal": "valor no válido",
    "exportError": "No hay propiedad.",
    "export": "Exportar Datos",
    "exportSelect": "Exportar información de datos de las formas seleccionadas",
    "exportPage": "Exporta la información de los datos de todas las formas en esta página"
  },
  "pt": {
    "title": "Propriedades dos Dados",
    "newProperty": "Gerir Dados",
    "editData": "Modificar",
    "delData": "Eliminar",
    "moveup": "Mover para cima",
    "movedown": "Mover para baixo",
    "invalidVal": "Valor Inválido",
    "exportError": "Não há propriedade.",
    "export": "Exportar dados",
    "exportSelect": "Exportar informações de dados das formas selecionadas",
    "exportPage": "Exportar informações de todos os dados desta página"
  },
  "it": {
    "title": "Proprietà Dati",
    "newProperty": "Gestisci Dati",
    "editData": "Modifica",
    "delData": "Elimina",
    "moveup": "Sposta Su",
    "movedown": "Sposta Giù",
    "invalidVal": "Dati invalidi",
    "exportError": "Nessuna proprietà.",
    "export": "Esporta dati",
    "exportSelect": "Esporta le informazioni sui dati delle forme selezionate",
    "exportPage": "Esporta le informazioni sui dati delle forme in questa pagina"
  },
  "tw": {
    "title": "數據屬性",
    "newProperty": "編輯數據",
    "editData": "編輯",
    "delData": "刪除",
    "moveup": "上移",
    "movedown": "下移",
    "invalidVal": "無效數值",
    "exportError": "沒有可以導出的屬性。",
    "export": "匯出數據",
    "exportSelect": "匯出選中的形狀資料",
    "exportPage": "匯出整頁形狀資料"
  }
}
</i18n>
